import { kitchenApi } from './kitchenApi';
import type { MenuItemDto } from '../api-types';

export const registryApi = kitchenApi.injectEndpoints({
    endpoints: (builder) => ({
        getRegistryItems: builder.query<MenuItemDto[], void>({
            query: () => ({
                apiName: 'brunch-v2',
                path: '/menu/registry/all',
                method: 'GET'
            }),
            providesTags: (result) =>
                result
                    ? [
                          ...result.map(({ uuid }) => ({
                              type: 'Registry' as const,
                              id: uuid
                          })),
                          { type: 'Registry', id: 'LIST' }
                      ]
                    : [{ type: 'Registry', id: 'LIST' }]
        }),

        createRegistryItem: builder.mutation<MenuItemDto, MenuItemDto>({
            query: (body) => ({
                apiName: 'brunch-v2',
                path: '/menu/registry',
                method: 'POST',
                body
            }),
            invalidatesTags: [{ type: 'Registry', id: 'LIST' }]
        }),

        updateRegistryItem: builder.mutation<MenuItemDto, MenuItemDto>({
            query: (item) => ({
                apiName: 'brunch-v2',
                path: `/menu/registry/${item.uuid}`,
                method: 'PUT',
                body: item
            }),
            invalidatesTags: (_r, _e, item) => [
                { type: 'Registry', id: item.uuid },
                { type: 'Registry', id: 'LIST' }
            ]
        }),

        toggleRegistryItem: builder.mutation<
            MenuItemDto,
            { item: MenuItemDto; activate: boolean }
        >({
            query: ({ item, activate }) => ({
                apiName: 'brunch-v2',
                path: `/menu/registry/${item.uuid}/${activate ? 'activate' : 'deactivate'}`,
                method: 'PATCH'
            }),
            invalidatesTags: (_r, _e, { item }) => [
                { type: 'Registry', id: item.uuid },
                { type: 'Registry', id: 'LIST' }
            ]
        })
    }),
    overrideExisting: true
});

export const {
    useGetRegistryItemsQuery,
    useCreateRegistryItemMutation,
    useUpdateRegistryItemMutation,
    useToggleRegistryItemMutation
} = registryApi;
